import { createType } from 'framework/utils/createType';

export const PatientQuickFilters = createType('active', 'all');
export type PatientQuickFilter = typeof PatientQuickFilters[number];
